var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _vm.isMessage
      ? _c(
          "div",
          {
            staticClass: "alert alert-danger alert-margin",
            attrs: { role: "alert" },
          },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rounded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-label": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info btn_right",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("中断する")]
        ),
        _vm.reserve.status == 0
          ? _c(
              "button",
              {
                staticClass: "btn-sm btn-outline-danger btn_right",
                attrs: { id: "destroyBtn", type: "button" },
                on: { click: _vm.destroy },
              },
              [_vm._v("削除する")]
            )
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-8" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.modify.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(1),
                _c("div", { staticClass: "col-9" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.reserve.startAt,
                          expression: "reserve.startAt",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "date",
                        min: _vm.minDay,
                        max: "2100-12-31",
                      },
                      domProps: { value: _vm.reserve.startAt },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.reserve, "startAt", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(2),
                _c("div", { staticClass: "col-9" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.reserve.operation,
                          expression: "reserve.operation",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { disabled: "" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.reserve,
                            "operation",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("組織変更"),
                      ]),
                      _c("option", { attrs: { value: "2" } }, [
                        _vm._v("所属変更"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn btn-block",
                attrs: { id: "modify_button", type: "submit" },
              },
              [_vm._v("次へ")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("組織・所属変更")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("開始日")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("変更内容")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }